import { useState, useEffect } from 'react';
import { Tooltip } from '../../../../../../components/UI/MDC/Tooltip/Tooltip';
import styles from './UPMCApplicationForm.module.scss';
import MaterialIcon from '@material/react-material-icon';
import classNames from 'classnames';
import BulkSelectModal from '../../../../../../components/UI/BulkSelectModal/BulkSelectModal';
import { GetContactOptions } from '../../../../../ApplicationInformation/ApplicationInformation_api';

const ContactsEdit = ({
	copyOfApp,
	setCopyOfApp,
	contactTypeKey,
	buttonLabel,
}) => {
	const [contactOptions, setContactOptions] = useState([]);
	const [formattedOptions, setFormattedOptions] = useState([]);
	const [currentSelections, setCurrentSelections] = useState(null);
	const [optionsLoading, setOptionsLoading] = useState(false);

	const [contactsData, setContactsData] = useState([
		...copyOfApp.UPMCApplication[contactTypeKey].contactData,
	]);
	const [formattedContactsData, setFormattedContactsData] = useState([]);

	const initialSelectedOptions = [
		...copyOfApp.UPMCApplication[contactTypeKey].contactData,
	];

	useEffect(() => {
		let formattedData = contactsData.map(x => {
			return {
				...x,
				Extras: (
					<>
						<Tooltip
							content={
								<div className={styles.toolTip_Content}>
									<p>NetworkID: {x.NetworkID}</p>
									<p>Familiar ESO ID: {x.FamiliarESOID}</p>
								</div>
							}
						>
							<MaterialIcon
								icon='info'
								className={styles.tooltip_Icon}
							/>
						</Tooltip>
					</>
				),
			};
		});
		setFormattedContactsData(formattedData);
	}, [contactsData]);

	useEffect(() => {
		setFormattedOptions(
			contactOptions?.map(opt => {
				return {
					...opt,
					ESOID: opt.ESOID,
					Extras: (
						<Tooltip
							content={
								<div className={styles.toolTip_Content}>
									<p>NetworkID: {opt.NetworkID}</p>
									<p>Familiar ESO ID: {opt.FamiliarESOID}</p>
								</div>
							}
						>
							<MaterialIcon
								icon='info'
								className={styles.tooltip_Icon}
							/>
						</Tooltip>
					),
				};
			})
		);
	}, [contactOptions]);

	const handleSearch = searchTerm => {
		if (searchTerm.length >= 1) {
			setOptionsLoading(true);
			GetContactOptions(searchTerm).then(response => {
				if (response.length) {
					setContactOptions(response);
				} else {
					setContactOptions([]);
				}
				setOptionsLoading(false);
			});
		} else {
			setContactOptions([]);
		}
	};

	const handleChange = updatedContacts => {
		setContactsData(updatedContacts);
		setCurrentSelections(updatedContacts.map(x => x.Name).join(', '));
	};

	const setAppContacts = () => {
		let updatedApp = { ...copyOfApp };
		updatedApp.UPMCApplication[contactTypeKey].contactData = contactsData;
		updatedApp.UPMCApplication[contactTypeKey].displayFormattedContacts =
			contactsData
				.map(x => {
					return x.Name;
				})
				.join(', ');
		setCopyOfApp(updatedApp);
	};

	const getCurrentSelections = () => {
		if (currentSelections === null) {
			return copyOfApp.UPMCApplication[contactTypeKey]
				.displayFormattedContacts;
		} else {
			return currentSelections;
		}
	};

	return (
		<div className={classNames([styles.hFull, styles.detailInfo])}>
			<div className={styles.locationsEdit}>
				<BulkSelectModal
					options={formattedOptions}
					selected={formattedContactsData}
					handleSearchProp={searchTerm => handleSearch(searchTerm)}
					initialSelections={initialSelectedOptions}
					optionLabelKey={'Name'}
					optionExtrasKey={'Extras'}
					uniqueIdentifierKey={'ID'}
					buttonLabel={buttonLabel}
					onChange={handleChange}
					onDone={setAppContacts}
					optionsPlaceholder='Too many results... modify search'
					optionsLoading={optionsLoading}
					searchDisabled={optionsLoading}
				/>
				<p className={styles.margin_top}>{getCurrentSelections()}</p>
			</div>
		</div>
	);
};

export default ContactsEdit;
